/**
 * components/shared/AnnouncementBanner.jsx
 * Dismissible announcement strip shown to all users.
 */

import styles from './AnnouncementBanner.module.css';

export default function AnnouncementBanner({ message, onDismiss }) {
  if (!message) return null;
  return (
    <div className={styles.banner}>
      <span className={styles.icon}>📣</span>
      <span className={styles.message}>{message}</span>
      {onDismiss && (
        <button className={styles.dismiss} onClick={onDismiss}>✕</button>
      )}
    </div>
  );
}
